<div
  class="absolute z-50 -top-0 h-screen w-full bg-theme-mediumBlue1/70 transition-all ease-in-out duration-300"
  [class]="{ 'left-0': sidebar(), '-left-full': !sidebar() }"
  (click)="hideSidebar($event)"
  (keydown)="hideSidebar($event)"
  tabindex="0"
  role="button">
  <aside class="relative bg-theme-mediumBlue1 w-10/12 md:w-6/12 h-screen p-8">
    <button
      class="absolute -right-2 top-4 w-6 h-6"
      (click)="hideSidebar()"
      appClicks="sidebar - close">
      <img
        class="w-full"
        src="https://res.cloudinary.com/superlikers/image/upload/v1768864456/icon-blue-ligth-cancel_etldtn.svg"
        alt="Cerrar Menú lateral"
        loading="lazy" />
    </button>
    <p class="font-bold justify-center flex text-2xl">Bienvenido</p>
    <p
      class="font-bold justify-center flex text-xl"
      appClicks="sidebar - name">
      {{ user()?.name }}
    </p>
    <br />
    <ul class="flex flex-col items-start gap-4 mb-8 border-b border-theme-white pb-4">
      @for (item of navList; track item.name) {
        @if (item.show()) {
          <li
            class="flex items-center gap-4 transition-color duration-300 hover:text-theme-lightBlue2"
            [appClicks]="'sidebar - ' + item.name">
            <img
              class="w-6 h-6"
              [src]="item.image"
              [alt]="item.name"
              loading="lazy" />
            <a [routerLink]="item.redirect">{{ item.name }}</a>
          </li>
        }
      }
    </ul>
    <button
      (click)="logout()"
      class="font-bold m-auto flex"
      appClicks="sidebar - logout">
      CERRAR SESIÓN
    </button>
  </aside>
</div>
